<mat-card class="adv-grid-card" *ngIf="DisplayMode==displayModeType.GRID">
  <div class="adv-date">{{advDate}}</div>
  <div class="adv-image w-100">
    <img src="{{ImageUrl}}" alt="" />
  </div>
  <mat-card-title class="text-overflow-ellipsis max-w"><span>{{Title}}</span></mat-card-title>
  <mat-card-content>

  </mat-card-content>
  <mat-card-footer fxLayout="row" fxLayoutAlign="center center">
    <div>
      <span class="adv-tag">{{Tag}}</span>
      <span class="adv-location" *ngIf="Location!=''">( {{ Location }} )</span>
      <div class="premium-ad-star" *ngIf="PremiumText != ''">
        <i class="material-icons" matTooltip="{{PremiumText}}" matTooltipPosition="above" style="    color: #e94480">star</i>
      </div>
      <div class="third-party-ad-text" *ngIf="IsThirdParty">
        <span style="color: #e94480">sponsored</span>
      </div>
    </div>
  </mat-card-footer>
</mat-card>

<mat-card class="adv-small-card" *ngIf="DisplayMode==displayModeType.TILE">

  <div class="w-100" style="height:200px">
    <img mat-card-image src="{{ImageUrl + '/250x250'}}" alt=""/>
  </div>
  <mat-card-title class="text-overflow-ellipsis max-w"><span class="adv-date">{{advDate}}</span><br><span>{{Title}}</span></mat-card-title>
  <mat-card-content>
    <p>
      {{ (Description.length > 20) ? (Description | slice:0:20) + '..' : (Description) }}
    </p>
  </mat-card-content>
  <mat-card-footer>

  </mat-card-footer>
</mat-card>

<ng-container *ngIf="DisplayMode==displayModeType.ROW" class="p-0 overflow-hidden">
  <div class="row m-0 pt-1 pb-1 border-hover" style="position: relative">
    <div class="pl-1" *ngIf="ImageUrl && ImageUrl!=''" >
        <img style="height:auto;width: 200px" src="{{ImageUrl + '/250x250'}}" alt=""/>
    </div>
    <div class="pl-3">
      <span class="adv-date">{{advDate}}</span>
      <div class="d-flex">
          <div class="text-overflow-ellipsis max-w d-inline-block">
          <h3 class="text-overflow-ellipsis max-w d-inline-block">{{Title}}</h3>
          </div>
<!--        <button type="button" class="ml-1 repost-btn" (click)="fireRepost($event)"  mat-button *ngIf="this.Expired">-->
<!--          <mat-icon>refresh</mat-icon>-->
<!--          <span>Repost</span>-->
<!--        </button>-->
      </div>


      <div *ngIf="Location!=''">
       {{ Location }}
      </div>
      <div>
        <p>
          {{ (Description.length > 100) ? (Description | slice:0:100) + '..' : (Description) }}
        </p>
      </div>
    </div>
    <div class="premium-ad-star" *ngIf="PremiumText != ''"><i class="material-icons" matTooltip="{{PremiumText}}" matTooltipPosition="above" style="    color: #e94480">star</i></div>
    <div class="third-party-ad-text" *ngIf="IsThirdParty">
      <span style="color: #e94480">sponsored</span>
    </div>
  </div>
</ng-container>
